import React , { useState,useEffect, useRef }from 'react';
import './Home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPhoneAlt } from '@fortawesome/free-solid-svg-icons';
import firebase from 'firebase/app';
import 'firebase/storage';






function Home() {
 
  //header
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

 
  //js
  const carouselWrapper = document.querySelector('.carousel-wrapper');
  const logos = document.querySelectorAll('.carousel-item');

  // Clone les logos pour un défilement infini
  logos.forEach((logo) => {
    const clone = logo.cloneNode(true);
    carouselWrapper.appendChild(clone);
  });

//jscardpour postuler
 // Initialiser les références pour chaque champ d'entrée
 const nameRef = useRef(null);
 const firstNameRef = useRef(null);
 const cityRef = useRef(null);
 const phoneRef = useRef(null);
 const cvLinkRef = useRef(null);

 // État pour afficher ou masquer la carte de candidature
 const [isCardVisible, setIsCardVisible] = useState(false);

 const showApplicationCard = () => {
   setIsCardVisible(true);
 };

 const hideApplicationCard = () => {
   setIsCardVisible(false);
 };

 const handleSubmit = (event) => {
   event.preventDefault();

   // Obtenir les valeurs des références
   const name = nameRef.current.value;
   const firstName = firstNameRef.current.value;
   const city = cityRef.current.value;
   const phone = phoneRef.current.value;
   const cvLink = cvLinkRef.current.value;

   const message = `Nom: ${name}%0A` +
                   `Prénom: ${firstName}%0A` +
                   `Ville: ${city}%0A` +
                   `Téléphone: ${phone}%0A` +
                   `Lien vers le CV: ${cvLink}`;

   const phoneNumber = "212655760051"; // Remplacez par votre numéro
   const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

   window.open(whatsappUrl, '_blank');
 };
//home
useEffect(() => {
  const logolinks = document.querySelector(".logolinks");
  const logo = document.querySelector(".logo img");
  const navLinks = document.querySelectorAll(".nav-linkis a");

  // Logo hover effect
  logo.addEventListener("mouseenter", () => {
    logo.style.transform = "scale(1.1)";
    logo.style.transition = "transform 0.3s ease";
  });

  logo.addEventListener("mouseleave", () => {
    logo.style.transform = "scale(1)";
  });

  // Nav-links hover effect
  navLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      link.style.color = "#add82d";
      link.style.transition = "color 0.3s ease";
    });

    link.addEventListener("mouseleave", () => {
      link.style.color = "white";
    });
  });

  // Scroll effect
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 100) {
      logolinks.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
      logolinks.style.transition = "background-color 0.3s ease";
    } else {
      logolinks.style.backgroundColor = "transparent";
    }
  };

  window.addEventListener("scroll", handleScroll);

  // Cleanup event listeners
  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);
document.addEventListener("DOMContentLoaded", () => {
  const nav = document.querySelector(".logolinks");
  const navPlaceholder = document.createElement("div");

  navPlaceholder.style.height = `${nav.offsetHeight}px`;
  navPlaceholder.style.display = "none";
  nav.parentNode.insertBefore(navPlaceholder, nav);

  window.addEventListener("scroll", () => {
    if (window.scrollY > nav.offsetTop) {
      nav.classList.add("fixed");
      navPlaceholder.style.display = "block";
    } else {
      nav.classList.remove("fixed");
      navPlaceholder.style.display = "none";
    }
  });
});
//cardservices 

  const cards = [
    { id: 1, image: '/service1.jpeg', title: 'CHANTIER' },
    { id: 2, image: '/hopitale.jpg', title: 'HOPITAUX' },
    { id: 3, image: '/jardinage.jpg', title: 'JARDINAGE' },
    { id: 4, image: '/netoyage industrielle.jpg', title: 'INDUSTRIE' },
    { id: 5, image: '/vt.jpg', title: 'VITRES' },
    { id: 6, image: '/nettoyage panneu .jpg', title: 'PANNEAUX' },
    { id: 7, image: '/netoyage marbre.jpg', title: 'CRISTALISATION' },
    { id: 8, image: '/ecole.jpg', title: 'ECOLES' },
];
  // Change card every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
    }, 3000);

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [cards.length]);

const [currentIndex, setCurrentIndex] = useState(0); // Définir currentIndex 
//dropddown
const [isNoteVisible, setIsNoteVisible] = useState(false);
const toggleNote = () => {
  setIsNoteVisible(!isNoteVisible);
};



  return (

    <div className='home'>
   

  <div className="contain">
    <div className="content">
      <div className="logolinks">
        <div className="logo">
          <a href='/'>
          <img src="head.png" alt="Logo" loading="lazy"/>
          </a>
        </div>
        <ul className="nav-linkis">
          <li><a href="/"><strong>Accueil</strong></a></li>
          <li><a href="/AboutUs"><strong>À propos</strong></a></li>
          <li><a href="/Services"><strong>Services</strong></a></li>
          <li><a href="/Contact"><strong>Contact</strong></a></li>
          <li><a href="/Book" className='booki'><strong>Réservation</strong></a></li>
        </ul>
      </div>
    </div>
    <script src="script.js" defer></script>

    <div className="left-texto">
    <h4>Service de nettoyage</h4>
      <h1><strong>Bienvenue chez <span className='homi'>Biocleaners</span></strong></h1>
      <p>Que vous soyez à <strong>Agadir, Marrakech </strong>ou <strong>Casablanca</strong>, <strong>Biocleaners</strong> est votre partenaire de confiance , nous offrons des services de nettoyage sur mesure pour tous vos espaces. 
      <h5><strong>Contactez-nous dès maintenant pour une réservation rapide !</strong></h5></p>
      <div class="buttons">
      <button className="long-button" ><a href='/Services'>Services</a></button>
      <button className="trans-button"><a href='/Contact'>Contactez-nous</a></button>
      </div>
    </div>
  </div>
  <div className="crd-container">
  <div className="crd">
    <img src="faste.png" alt="1" className="iconic" loading="lazy"/>
    <h4>Service rapide</h4>
  </div>
  <div className="crd">
    <img src="srv.png" alt="2" className="iconic" loading="lazy"/>
    <h4>Service sécurisé</h4>
  </div>
  <div className="crd">
    <img src="teame.png" alt="3" className="iconic" loading="lazy"/>
    <h4>Employés experts</h4>
  </div>
  <div className="crd">
    <img src="wallet.png" alt="4" className="iconic" loading="lazy"/>
    <h4>Tarifs flexibles</h4>
  </div>
  </div>
  <div className="box">
  <div className="imag-container">
    <img src="smal2.jpg" alt="Large Image" className="larg-img"  loading="lazy"/>
    <img src="cercle.jpg" alt="Small Image" className="smal-img"  loading="lazy"/>
  </div>
  <div className="tet-container">
    <h3 className="text-slide"><strong>Experts en Nettoyage Professionnel</strong></h3>
    <h2 className="text-slide">Service de Nettoyage à Agadir, Marrakech et Casablanca.</h2>
    <p>Chez <strong>Biocleaners</strong>, nous offrons des services de <strong>nettoyage sur-mesure</strong> pour les particuliers et les professionnels. Que ce soit pour <strong>le nettoyage de bureaux</strong>, de maisons ou d'espaces commerciaux, notre équipe qualifiée assure des <strong>prestations de nettoyage à Agadir, Marrakech et Casablanca</strong>, adaptées à vos besoins.</p>
    <p>Nous utilisons des <strong>produits de nettoyage écologiques</strong> et des techniques avancées pour garantir un environnement propre, sain et sécurisé. <br /><strong>Contactez-nous</strong> dès maintenant pour un <strong>devis personnalisé</strong> ou pour planifier une intervention rapide.</p>    <div className="buttonx-container">
      <button className="btn-primary"><a href='/Services'>En savoir plus</a></button>
      <button className="btn-secondary"><a href='/Book'>Réserver maintenant&#8594;</a></button>
    </div>
  </div>
</div>
<div className="panel">
  <h1>QUI SOMMES-NOUS ?</h1>
  <h4><strong> Services de nettoyage professionnels adaptés à vos besoins à Agadir, Marrakech et Casablanca .</strong></h4>
  </div>
  <div className="container-bg">
  <div className="bubble"></div>
  <div className="bubble bubble1"></div>
  <div className="bubble bubble3"></div>
  <div className="bubble bubble4"></div>
  
  <div className="transparent-box">
    <h3>
   <strong><span className='qsno'>Biocleaners</span></strong> , fondée à <strong>Agadir</strong> , est votre expert en services de nettoyage professionnel. Nous proposons une large gamme de solutions adaptées à vos besoins, y compris<strong> le nettoyage de bureaux, le nettoyage commercial, le nettoyage de vitres</strong> , ainsi que de nombreux autres services spécialisés. Que vous soyez une entreprise ou un particulier à <strong>Agadir, Marrakech ou Casablanca,</strong> notre mission est de garantir un environnement propre, sain et sécurisé.
<br />Chez  <strong><span className='qsno'>Biocleaners</span></strong>, la satisfaction client est notre priorité. Notre équipe est composée de professionnels dévoués et compétents qui s'engagent à fournir des services de nettoyage de premier ordre . Nous croyons fermement qu'ensemble, nous pouvons atteindre l'excellence dans le domaine du nettoyage écologique.
Nous comprenons l'importance d'un environnement propre et sain c'est pourquoi nous avons adapté nos pratiques de nettoyage pour être écologiquement responsables. 
  </h3>
    <div className="buttonso-container">
  <button className="longi-button"><a href="/Services">Nos services</a></button>
  <button className="transa-button"><a href="/AboutUs">Voir plus &#8594;</a></button>
</div>
  </div>
</div>
<div className="reserve-container">
  <h1><strong>Nos Services </strong> <br /></h1>
  <h2><strong>Quels Services Offrons-Nous ?</strong></h2>
  <p>Découvrez nos services de nettoyage écologiques et professionnels.</p>


</div>
   
<div className="containe">
  
<div className="containe">
<div className="cs-wrapper">
    {cards.map((card, index) => (
        <div
            className="cs"
            key={card.id}
            style={{ display: index === currentIndex ? 'block' : 'none' }}
        >
            <a href="/Services">
                <img src={card.image} alt={card.title} loading="lazy" />
                <p>{card.title}</p>
            </a>
        </div>
    ))}
</div>
</div>

</div>

<div className="socialize-section">
  <h1 className="tetle">Nettoyage Professionnel pour un Espace Propre !</h1>
  <div className="subtitle-container">
    <p className="subtitle"><strong> C'est simple ! réservez dès aujourd'hui !</strong></p>
    <div className="subtitle-underline"></div>
  </div>
  <a href="/Book" className="ctas-button">Réservez ici !</a>
  <img src="corner.png" alt="Illustration" class="corner-image" loading="lazy"/>
</div>

<div class="clrd-container">
  <div class="clrd">
    <img src="ima1.jpg" alt="Image 1" loading="lazy"/>
  </div>

  <div class="clrd card-center">
  <div class="image-container"></div>
    <div class="overlaya">
      <h2>Experts en Nettoyage</h2>
      <p>Faites-nous confiance pour un espace clean et accueillant, pensé pour votre confort au quotidien.</p>
      <a href="/Contact" class="clrd-button">Contactez-Nous</a>
    </div>
  </div>

  <div class="clrd">
    <img src="ima2.jpg" alt="Image 3" loading="lazy"/>
  </div>
</div>

<div class="boxa">
<h1 class="man-title"><img src="pr.png" alt="Appeler" class="avis-icon" loading="lazy"/>Pourquoi nous choisir ?</h1>
<h4>Découvrez les raisons de notre différence et de votre satisfaction.</h4>
<div class="boxe">
  <div class="feature feature-first">
    <h3>Service disponible 24/7
    Nous sommes là pour répondre à toutes vos questions.</h3>
  </div>
  <div class="feature">
    <i class="fas fa-check-circle"></i>
    <h2> <strong>Satisfaction garantie </strong>
    <p>Nous nous engageons à offrir un service qui dépasse vos attentes.</p></h2>
  </div>
  <div class="feature">
    <i class="fas fa-calendar-alt"></i>
    <h2> <strong>Horaires flexibles </strong><br />
    <p>Des prestations ajustées à votre emploi du temps pour plus de commodité.</p></h2>
  </div>
  <div class="feature">
    <i class="fas fa-dollar-sign"></i>
    <h2><strong>Prix abordable</strong> <br />
    <p>Des services de haute qualité à un tarif accessible pour tous nos clients.</p></h2>
  </div>
  <div class="feature">
    <i class="fas fa-trophy"></i>
    <h2><strong>Tarifs compétitifs</strong> <br />
    <p>Profitez des meilleurs prix sans compromis sur la qualité du service.</p></h2>
  </div>
  <div class="feature">
    <i class="fas fa-mobile-alt"></i>
    <h2> <strong>Pratique et accessible</strong> <br />
    <p>Un <strong>devis gratuits</strong> et <strong>déplacement à domicile</strong> pour un service encore plus pratique.</p></h2>
  </div>
</div>
</div>


<div class="sontainer">
  <div class="sontent">
    <div class="text-sontent">
      <h1>Le Meilleur Service de Nettoyage Professionnel au Maroc</h1>
      <p>Pour un environnement impeccable, notre service de nettoyage professionnel au Maroc vous assure un entretien de qualité pour maison , bureaux, commerces, hôtels et espaces professionnels. Nous intervenons à <strong> Agadir , Marrakech et Casablanca </strong>, pour vous offrir un espace propre et accueillant chaque jour. </p>
      <a href="/Services" class="btn">Voir nos services </a>
    </div>
    <div class="image-containers">
      <img src="team.jpg" alt="Cleaning services" class="cleanin-image" loading="lazy"/>
    </div>
  </div>
</div>

<div class="location-section">
  <h2 class="section-title">Où nous trouver ?</h2>
  <h3 class="section-subtitle">Nos services sont disponibles dans plusieurs villes pour mieux vous servir</h3>
  
  <div class="cardas-container">
    <div class="fcard">
      <div class="icons-container">
        <i class="location-icon fas fa-map-marker-alt"></i>
      </div>
      <div class="location-name">Agadir</div>
    </div>
    <div class="fcard">
      <div class="icons-container">
        <i class="location-icon fas fa-map-marker-alt"></i>
      </div>
      <div class="location-name">Marrakech</div>
    </div>
    <div class="fcard">
      <div class="icons-container">
        <i class="location-icon fas fa-map-marker-alt"></i>
      </div>
      <div class="location-name">Casablanca</div>
    </div>
  </div>
  
</div>

<div class="team-image">
      <div class="overlay">
        <h3><strong>Collaboration • Innovation • Excellence</strong></h3>
      </div>
  </div>
 
 
  <section class="comment-ca-marche">
  <h4>COMMENT CA MARCHE</h4>
  <h1>Un moyen simple d'obtenir des services</h1>
  <div class="etapes">
    <div class="etape">
      <h2>ÉTAPE 1</h2>
      <h3>Choisissez le service souhaité</h3>
      <p>Sélectionnez parmi nos forfaits celui qui correspond à vos besoins.</p>
    </div>
    <div class="etape">
     <h2>ÉTAPE 2</h2>
      <h3>Joignez-nous rapidement</h3>
      <p>Cliquez sur "Contactez-nous" pour discuter de vos besoins.</p>
    </div>
  
    <div class="etape">
      <h2>ÉTAPE 3</h2>
      <h3>Réservez votre service</h3>
      <p>Profitez d'un nettoyage rapide et de qualité.</p>
    </div>
  

    <div class="etape finale">
      <h2>ÉTAPE FINALE</h2>
      <h3>Profitez de nos services</h3>
      <p>Détendez-vous pendant que nous donnons vie à votre vision.</p>
    </div>
  </div>
  <div className='bcm'>
  <a href="/Contact" class="btns">Contactez-nous</a>
  </div>
</section>



<div className="cont">
      <div className="test-container">
        <h1><span className="sp-rec">Si vous êtes</span> à la recherche d'une opportunité de rejoindre une équipe dynamique et engagée!</h1>
        <p>
      Nous serions ravis de vous accueillir en tant qu'agent de nettoyage. Nous recherchons des personnes motivées, prêtes à contribuer à un environnement de travail propre et agréable.
      <br /> 
      Contactez-nous dès aujourd'hui pour discuter de cette opportunité et faites partie de notre équipe !
    </p>
            <button onClick={showApplicationCard}>POSTULEZ MAINTENANT &#8594;</button>
      </div>
      <div className="ima-container">
        <img src="/person-taking-care-office-cleaning.png" alt="Image de nettoyage" loading="lazy"/>
      </div>
      {isCardVisible && (
        <div className="cmrd">
          <div className="cmrd-content">
            <div className="cmrd-image">
              <img src="card.jpg" alt="Illustration de l'opportunité"loading="lazy" />
            </div>
            <div className="card-form">
              <h2>Postuler Maintenant</h2>
              <form onSubmit={handleSubmit}>
                <div className="inpute-row">
                  <label htmlFor="civility">Civilité :</label>
                  <select id="civility" name="civility" required>
                    <option value="">Sélectionnez votre civilité</option>
                    <option value="mme">Mme</option>
                    <option value="m">M.</option>
                  </select>
                </div>
                <div className="inpute-row">
                  <label htmlFor="name">Nom :</label>
                  <input type="text" id="name" name="name" placeholder="Votre nom" ref={nameRef} required />
                </div>
                <div className="inpute-row">
                  <label htmlFor="firstName">Prénom :</label>
                  <input type="text" id="firstName" name="firstName" placeholder="Votre prénom" ref={firstNameRef} required />
                </div>
                <div className="inpute-row">
                  <label htmlFor="city">Ville :</label>
                  <input type="text" id="city" name="city" placeholder="Votre ville" ref={cityRef} required />
                </div>
                <div className="inpute-row">
                  <label htmlFor="phone">Téléphone :</label>
                  <input type="text" id="phone" name="phone" placeholder="Votre téléphone" ref={phoneRef} required />
                </div>
                <div className="inpute-row">
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <label htmlFor="cvLink" style={{ marginRight: '8px' }}>Lien vers cv :</label>
    <span
      className="info-icon"
      onClick={toggleNote}
      style={{
        cursor: 'pointer',
        fontSize: '18px',
        color: '#007BFF',
      }}
    >
      ℹ️
    </span>
  </div>
  <div style={{ position: 'relative' }}>
    <input
      type="url"
      id="cvLink"
      name="cvLink"
      placeholder="Lien vers votre CV (Google Drive, Dropbox...)"
      ref={cvLinkRef}
      required
    />
    {/* Note contextuelle */}
    {isNoteVisible && (
      <div
        className="note-tooltip"
        style={{
          marginTop: '5px',
          padding: '10px',
          backgroundColor: '#f8f9fa',
          border: '1px solid #ddd',
          borderRadius: '5px',
          fontSize: '14px',
          color: '#333',
          position: 'absolute',
          zIndex: 1000,
        }}
      >
        <p><strong>Comment obtenir un lien Google Drive pour votre CV :</strong></p>
        <ol>
          <li>Connectez-vous à votre compte Google Drive.</li>
          <li>Téléversez votre CV (format PDF recommandé).</li>
          <li>Faites un clic droit sur le fichier et sélectionnez <strong>Partager</strong>.</li>
          <li>Dans la fenêtre de partage, cliquez sur <strong>Obtenir le lien</strong>.</li>
          <li>Modifiez les paramètres pour que "Tous les utilisateurs disposant du lien" puissent y accéder.</li>
          <li>Copiez le lien généré et collez-le ici.</li>
        </ol>
      </div>
    )}
  </div>
</div>
                <button type="submit" className="whatsapp-button">Envoyer via WhatsApp</button>
              </form>
              <button onClick={hideApplicationCard} className="close-button">Fermer</button>
            </div>
          </div>
        </div>
      )}
    </div>
 

<div className='global'>
<h1 class="maine-title"><img src="avis.png" alt="avis" class="avis-icon" loading="lazy"/>Avis de nos clients</h1>
<h2 class="subr-title">Ce que nos clients disent de nous</h2>

<div class="book-animation-container">
<div class="testimonial-card">
    <p class="testimonial-text">“Très satisfait du service. Je referai appel à eux sans hésiter.”</p>
    <h3 class="client-name">Mehdi Es.</h3>
    <p class="client-info">Marrakech, Maroc</p>
  </div>
  <div class="testimonial-card">
    <p class="testimonial-text">“Très satisfait du service. Je referai appel à eux sans hésiter.”</p>
    <h3 class="client-name">Mehdi Es.</h3>
    <p class="client-info">Marrakech, Maroc</p>
  </div>
  <div class="testimonial-card">
    <p class="testimonial-text">“Je n'ai pas regretté de vous avoir confié ma maison. En tout cas, merci pour votre effort et votre sincérité.”</p>
    <h3 class="client-name">Amina At.</h3>
    <p class="client-info">Agadir, Maroc</p>
  </div>

  <div class="testimonial-card">
    <p class="testimonial-text">“Expérience formidable. Un service rapide, et prix raisonnable et des résultats à la hauteur !”</p>
    <h3 class="client-name">Fatima ZE.</h3>
    <p class="client-info">Marrakech, Maroc</p>
  </div>
 
  <div class="testimonial-card">
    <p class="testimonial-text">“Impressionnée par la qualité et la rapidité du service , bon courage .”</p>
    <h3 class="client-name">Saida Al.</h3>
    <p class="client-info">Agadir, Maroc</p>
  </div>
  <div class="testimonial-card">
    <p class="testimonial-text">“Service impeccable ! L'équipe est extrêmement professionnelle et attentive à chaque détail.”</p>
    <h3 class="client-name">Khalid B.</h3>
    <p class="client-info">Agadir, Maroc</p>
  </div>

</div>
</div>
 
<div className="Contner">
  <div className="locations-section">
    {/* Lien qui redirige vers Google Maps */}
    <a
      href="https://www.google.com/maps/place/30%C2%B024'18.5%22N+9%C2%B003'27.4%22W"
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block' }} // Assure que le lien couvre la carte
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d220505.65770190198!2d-9.482451107180799!3d30.28264669106126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzDCsDI0JzE4LjUiTiA5wrAzMycyNy40Ilc!5e0!3m2!1sfr!2sma!4v1723663069281!5m2!1sfr!2sma"
        width="1500"
        height="350"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </a>
  </div>
</div>

<script src="//code.tidio.co/your-tidio-key.js" async></script>




</div>






  )
  ;
}

export default Home;
